// extracted by mini-css-extract-plugin
export default {"popularSearches":"_2vUMU","title":"_2xcHD","mobilePopularSearches":"A-LHn","mxPopularSearches":"_28pGh"};